import * as z from 'zod';
import { cloudStorageBucketNameSchema, fileExtensionSchema } from '../../enums.mjs';
import { fileId } from '../../types/opaque.mjs';

const CLASSIFY_DEADLINE_MINUTES = 10;
const QUEUE_MAX_BACKOFF_MINUTES = 1;
const PROMPT_RUNNER_REQUEST_TIMEOUT_MINUTES = 10;
const CLASSIFICATION_TIMEOUT_MINUTES = CLASSIFY_DEADLINE_MINUTES + QUEUE_MAX_BACKOFF_MINUTES + PROMPT_RUNNER_REQUEST_TIMEOUT_MINUTES;
var Classify;
(function (Classify) {
    (function (Request) {
        Request.schema = z.object({
            fileId: fileId,
            fileName: z.string(),
            fileExtension: fileExtensionSchema,
            bucket: cloudStorageBucketNameSchema,
            bucketDirPath: z.array(z.string()).optional(),
            requestedAt: z.iso.datetime().optional(),
        });
    })(Classify.Request || (Classify.Request = {}));
})(Classify || (Classify = {}));

export { CLASSIFICATION_TIMEOUT_MINUTES, CLASSIFY_DEADLINE_MINUTES, Classify };
